import { crmApiInstance } from './client.js';

export const organisationsApi = {
  getAll:   (params = {}) => crmApiInstance.get('/leads/organisations', { params }).then(r => r.data),
  getById:  (id)          => crmApiInstance.get(`/leads/organisations/${id}`).then(r => r.data),
  create:   (data)        => crmApiInstance.post('/leads/organisations', data).then(r => r.data),
  update:   (id, data)    => crmApiInstance.put(`/leads/organisations/${id}`, data).then(r => r.data),
  remove:   (id)          => crmApiInstance.delete(`/leads/organisations/${id}`).then(r => r.data),
};
